module.exports = __webpack_public_path__ + "static/media/typed.ea5b70e8.jpg";